import { createFileRoute } from "@tanstack/react-router";
import SpravatoInsuranceDenied from "@/pages/SpravatoInsuranceDenied";
export const Route = createFileRoute("/spravato-insurance-denied")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Spravato Insurance Denied | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SPRAVATO insurance denied? Learn about appeals, prior auth, and free benefits verification for SPRAVATO in Coral Springs, FL At Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Spravato Insurance Denied | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SPRAVATO insurance denied? Learn about appeals, prior auth, and free benefits verification for SPRAVATO in Coral Springs, FL At Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-insurance-denied",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-insurance-denied",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoInsuranceDenied />;
}
